/*
  current-page.js
    Current Page module

*/
import * as types from '@/store/mutation-types'
import { sLog } from '@/common/simple-logger'

/*
const pages = [
  'map',
  'member',
  'group',
]
*/

export default {
  state: {
    sCurrentPage: ''
  },
  getters: {
    //currentPage: state => state.currentPage.sCurrentPage,
    currentPage: state => state.sCurrentPage,
  },
  actions: {
    aChangeCurrentPage: ({ commit }, payload) => {
      sLog.debug('@action changeCurrentPage ' + payload)
      commit(types.CHANGE_CURRENT_PAGE, payload)
    }
  },
  mutations: {
    //
    // change current page
    //
    [types.CHANGE_CURRENT_PAGE] (state, page) {
      sLog.verbose('@store current page changed : ' + state.sCurrentPage)
      state.sCurrentPage = page
      sLog.verbose('@store current page changed : ' + state.sCurrentPage)
    },
    setCurrentPage: function (state, page) {
      sLog.verbose('@store current page changed : ' + state.sCurrentPage)
      state.sCurrentPage = page
      sLog.verbose('@store current page changed : ' + state.sCurrentPage)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/current-page.js